import { render } from "./ClaimsManagement.vue?vue&type=template&id=7fe8fda1&scoped=true"
import script from "./ClaimsManagement.vue?vue&type=script&lang=js"
export * from "./ClaimsManagement.vue?vue&type=script&lang=js"

import "./ClaimsManagement.vue?vue&type=style&index=0&id=7fe8fda1&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe8fda1"]])

export default __exports__